/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Col, Row } from "components/Grid";
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import { FileModal, EndorsementTagList } from '@fitinsur/components'
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import FilesAttachment from "components/FilesAttachment";
import * as yup from 'yup';
import RenderButtons from 'components/RenderButtons';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { useHeaderNbi, useWordingHtmlModal, usePolicyPackSendDirectorApproval } from 'services/QuoteService'; 
import { useOperationInfo } from 'services/OperationService';
import {
  useGetQuestionnaireAnswer,
} from '@fitinsur/services/QuestionnaireAnswerService';

//Mudar Conforme tela
export default function SendInvoice(props) {
  const [idProduct, setIdProduct] = useState(null);
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [endorsmentType, setEndorsmentType] = useState("");
  const authContext = useContext(GlobalAuthContext);
  const [endorsementDocuments, setEndorsementDocuments] = useState([]);

  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const [statusEndorsement, setStatusEndorsement] = useState({
    title: "POLICY PACK - DIRECTOR APPROVAL",
    route: "",
  });

  const validation = yup.object().shape({
    policyPackDirectorApprovalMessage: yup.string().required("* Required field"),
  });

  const [historymsg, setHistorymsg] = useState([]);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useWordingHtmlModalData,
    loading: useWordingHtmlModalLoading,
    error: useWordingHtmlModalError,
    status: useWordingHtmlModalStatus,
    request: useWordingHtmlModalRequest,
  } = useWordingHtmlModal(props.match.params.idOperation);

  const {
    data: usePolicyPackSendDirectorApprovalData,
    loading: usePolicyPackSendDirectorApprovalLoading,
    error: usePolicyPackSendDirectorApprovalError,
    status: usePolicyPackSendDirectorApprovalStatus,
    request: usePolicyPackSendDirectorApprovalRequest,
  } = usePolicyPackSendDirectorApproval();

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useWordingHtmlModalLoading || usePolicyPackSendDirectorApprovalLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useWordingHtmlModalLoading, usePolicyPackSendDirectorApprovalLoading]);

  async function handleOperationInfo() {
    useOperationInfoRequest().then(({data: response}) => {
        setIdProduct(response?.idProduct);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }


  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          isFramework: data.ret_value.isFramework,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);
        setEndorsmentType(data.ret_value.endorsmentType)
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleSendApproval() {
    usePolicyPackSendDirectorApprovalRequest({idOperation: props.match.params.idOperation, policyPackDirectorApprovalMessage: formik.current.values.policyPackDirectorApprovalMessage}).then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        return history.push('/policies');
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  const handleEndorsementDocuments = (data) => {
    let questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc,
    ];

    const endorsementDocumentsQst = questionnaire.find((qst) => qst.idQuestion === 1867)

    if (endorsementDocumentsQst?.answer) {
      const documents = JSON.parse(endorsementDocumentsQst.answer) || []
      setEndorsementDocuments(documents)
    }
  }

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleEndorsementDocuments(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);


  function handleFile() {
    useWordingHtmlModalRequest(null, {renderWelcomekit: 1}).then(({data: resp}) => {
        if (resp.ret_code === 200) {
          setFile(resp.ret_value.policePackReturnDocs
            .filter(document => {
              return  ![272, 399, 401, 450, 453, 397, 493, 367].includes(document.idDomain);
            })
            .map(document => ({
              idDocument: document.idDocument,
              idDomainDescription: document.idDomainDescription,
              idReport: document.idReport,
              idOperation: document.idOperation,
              reportToken: document.reportToken,
              url: document.url,
              fileName: document.documentMetadata.fileName
            })))
          if (resp.ret_value.policyPackDirectorApprovalMessage && formik.current) {
            formik.current?.setFieldValue('policyPackDirectorApprovalMessage', resp.ret_value.policyPackDirectorApprovalMessage);
          }
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleFile();
    handleSummary();
    handleOperationInfo();
    useGetQuestionnairesAnswersRequest();
  }, [])

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />

      <ContentCard title={statusEndorsement.title}
        icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Formik
          innerRef={formik}
          initialValues={{
            policyPackDirectorApprovalMessage: ''
          }}
          validationSchema={validation}
          onSubmit={handleSendApproval}
        >
          {formikProps => (
            <Form>
              <Col>
                <Field
                  label={'Message'}
                  name='policyPackDirectorApprovalMessage'
                  value={formikProps.values.policyPackDirectorApprovalMessage}
                  onChange={(e) => formikProps?.setFieldValue('policyPackDirectorApprovalMessage', e)}
                  component={TextField}
                />
              </Col>

              <FileModal idOperation={props?.match?.params?.idOperation} documents={file} />

              <EndorsementTagList
                  tags={endorsementDocuments}
                  showRemoveIcon={false}
                  attachments={[]}
              />

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <RenderButtons idOperation={props.match?.params?.idOperation}>
                  <ButtonContent>
                    <Button
                      style={{ marginLeft: "10px" }}
                      primary
                      type="submit"
                      id="btnSubmitSend"
                    >
                      SEND APPROVAL
                    </Button>
                  </ButtonContent>
                </RenderButtons>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {
        loading.active && (
          <Loader
            backdropColor={Colors.WHITE}
            fullScreen
          />
        )}
    </Layout>
  );
}
